import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import JobStore from '../stores/JobStore';
import JobResultsStore from '../stores/JobResultsStore';
import LogStore from '../stores/LogStore';
import JobActions from '../actions/JobActions';

import LogView from '../components/LogView.react';


const StatusLabel = ({ status }) => {
  const cn = classNames({
    label: true,
    'label-danger': (status === 'failed' || status === 'killed'),
    'label-success': (status === 'done' || status === 'finished'),
    'label-default': (status !== 'failed' && status !== 'done' && status !== 'killed' && status !== 'finished'),
  });
  return (<span className={cn}>{status}</span>);
};

StatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
};

function getJobState(jobId) {
  return {
    job: JobStore.getJob(jobId),
    results: JobResultsStore.getJobResults(jobId),
    logs: LogStore.getLogs(jobId),
  };
}

export default class JobDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = getJobState(this.props.params.jobId);
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.jobStoreSubscription = JobStore.addListener(this._onChange);
    this.logStoreSubscription = LogStore.addListener(this._onChange);
    this.resultsStoreSubscription = JobResultsStore.addListener(this._onChange);
    this.jobSubscription = JobActions.startPolling(this.props.params.jobId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(getJobState(nextProps.params.jobId));
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.jobId !== prevProps.params.jobId) {
      this.jobSubscription();
      this.jobSubscription = JobActions.startPolling(this.props.params.jobId);
    }
  }

  componentWillUnmount() {
    this.jobStoreSubscription.remove();
    this.logStoreSubscription.remove();
    this.resultsStoreSubscription.remove();
    this.jobSubscription();
  }

  _onChange() {
    this.setState(getJobState(this.props.params.jobId));
  }

  render() {
    if (this.state.job) {
      // TODO: This is ugly and dumb.
      const resultFiles = this.state.results.map((r, i) => (
        <p key={i}>
          <span className='statusLabel'>Result:</span> <a href={r.url}>{r.name}</a>
        </p>
      ));

      return (
        <article className='jobDetail'>
          <div className='detail'>
            <header>
              <h1>{this.state.job.name}</h1>
              <time dateTime={this.state.job.startedAt.format()} >
                {this.state.job.startedAt.format('D MMM, h:mm A')}
              </time>
              <StatusLabel status={this.state.job.status} />
            </header>
            <div className='status'>
              <p><span className='statusLabel'>Started By:</span> {this.state.job.creator}</p>
              {resultFiles}
            </div>
          </div>
          <div className='logs'>
            <LogView entries={this.state.logs} />
          </div>
        </article>
      );
    }

    return (<div className='jobDetail' />);
  }
}

JobDetail.propTypes = {
  params: PropTypes.shape({
    jobId: PropTypes.string,
  }),
};
